<template>
  <div class="container-page">
    <div class="card-mpk">
      <p class="card-mpk__title title-inner">Карточка поручения Загранаппарату</p>

      <Tab v-model="selectedTabIndex">
        <!--  ТАБ: Общие сведения  -->
        <TabItem name="Общие сведения" :selected="true">
          <div class="card-mpk__body">
            <div class="card-mpk__card">
              <div class="card-mpk__card-body">
                <!-- Страна | Статус -->
                <div class="card-mpk__card-row">
                  <div class="card-mpk__card-col1">
                    <p class="title-column">Страна</p>
                    <p>{{ item.countryName }}</p>
                  </div>
                  <div class="card-mpk__card-col2 status">
                    <p class="title-column">Статус</p>
                    <div class="status-container" v-if="item.id">
                      <span class="status-dot" :class="getCardStatusDotClass(item)"></span>
                      <span>{{ item.statusName }}</span>
                    </div>
                  </div>
                </div>

                <!-- Наименование | Тип -->
                <div class="card-mpk__card-row">
                  <div class="card-mpk__card-col1">
                    <p class="title-column">Наименование поручения</p>
                    <p>{{ item.assignmentName }}</p>
                  </div>
                  <div class="card-mpk__card-col2">
                    <p class="title-column">Тип поручения</p>
                    <p>{{ item.type?.name }}</p>
                    <p v-if="item?.type?.id == 5">{{ item?.otherType }}</p>
                  </div>
                </div>

                <!-- Дата поступления | Корреспондент -->
                <div class="card-mpk__card-row">
                  <div class="card-mpk__card-col1">
                    <p class="title-column">Дата поступления</p>
                    <p>{{ $momentFormat(item.receiptDate, 'D MMMM YYYY') }}</p>
                  </div>
                  <div class="card-mpk__card-col2">
                    <p class="title-column">Корреспондент</p>
                    <p>{{ item.correspondent?.fullName }}</p>
                  </div>
                </div>

                <!-- Ответственный | Срок исполнения -->
                <div class="card-mpk__card-row">
                  <div class="card-mpk__card-col1">
                    <p class="title-column">Срок исполнения</p>
                    <p :class="{ 'deadline--overdue': isOverdue }">
                      {{ $momentFormat(item.deadline, 'D MMMM YYYY') }}
                    </p>
                  </div>
                  <div class="card-mpk__card-col2">
                    <p class="title-column">Ответственный</p>
                    <p>
                      <template v-for="(emp, idx) in item.responsibleEmployees" :key="emp.id">
                        {{ emp.fullName }}<template v-if="idx < item.responsibleEmployees.length - 1">, </template>
                      </template>
                    </p>
                  </div>
                </div>

                <!-- Отчет / Документы -->
                <div class="card-mpk__card-row documents">
                  <div class="card-mpk__card-col1 report-container">
                    <p class="title-column">Отчет</p>
                    <div class="report-column">
                      <p class="report-text mb-8">{{ item.report }}</p>

                      <template v-if="item.reportFiles && item.reportFiles.length">
                        <div class="report-files" v-for="reportFile in item.reportFiles" :key="reportFile.fileId">
                          <p class="report-text">
                            <a href="javascript:" @click.prevent="downloadReportFile(reportFile)">
                              <IconComponent name="doc-redesigned" class="tooltip-component__icon" />
                            </a>

                            {{ reportFile.fileText }}
                          </p>
                          <p v-if="reportFile.file.originalName" class="report-name">
                            <a href="javascript:" @click.prevent="downloadReportFile(reportFile)">
                              {{ reportFile.file.originalName }}</a
                            >
                          </p>
                        </div>
                      </template>

                      <div class="btn-container d-flex w100">
                        <template v-if="!item.postponed">
                          <!-- Взять в работу: Сотрудник ЗА, статус Новое -->
                          <ButtonComponent
                            v-if="item.canEditStatus && item.statusId === EAP_ASSIGMENT_STATUS_ID.new"
                            mod="border"
                            @click="updateStatus(EAP_ASSIGMENT_STATUS_ID.inProgress)"
                            >Взять в работу</ButtonComponent
                          >

                          <!-- Внести отчет: Сотрудник ЗА, статус В работе -->
                          <ButtonComponent
                            v-if="item.canEditStatus && item.statusId !== EAP_ASSIGMENT_STATUS_ID.new"
                            mod="border"
                            @click="createReport"
                            >Внести отчет</ButtonComponent
                          >

                          <!-- На согласование: Сотрудник ЗА, статус В работе, отчет добавлен -->
                          <ButtonComponent
                            v-if="item.canApproveStatus && item.statusId === EAP_ASSIGMENT_STATUS_ID.inProgress"
                            mod="gradient-bg"
                            :disabled="!item.report"
                            @click="updateStatus(EAP_ASSIGMENT_STATUS_ID.underReview)"
                            >На согласование</ButtonComponent
                          >

                          <!-- Начать согласование: Секретарь МПК, статус На согласовании -->
                          <ButtonComponent
                            v-if="item.canApproveStatus && item.statusId === EAP_ASSIGMENT_STATUS_ID.underReview"
                            mod="gradient-bg"
                            @click="nextStep"
                            >Начать согласование</ButtonComponent
                          >

                          <!-- Согласовать: Секретарь МПК, статус В процессе согласования -->
                          <ButtonComponent
                            v-if="item.canApproveStatus && item.statusId === EAP_ASSIGMENT_STATUS_ID.inApproval"
                            mod="gradient-bg"
                            @click="nextStep"
                            >Согласовать</ButtonComponent
                          >

                          <!-- Отклонить отчет: Секретарь МПК, статус В процессе согласования -->
                          <ButtonComponent
                            v-if="item.canApproveStatus && item.statusId === EAP_ASSIGMENT_STATUS_ID.inApproval"
                            mod="border"
                            @click="cancelReport"
                            >Отклонить отчет</ButtonComponent
                          >
                        </template>

                        <!-- Причины отказа: если ранее были отклонения, статус В работе или Отменено -->
                        <ButtonComponent
                          v-if="
                            item.refuses &&
                            item.refuses.length > 0 &&
                            (item.statusId === EAP_ASSIGMENT_STATUS_ID.inProgress || item.postponed)
                          "
                          mod="border"
                          @click="showRefuseReason"
                          >Причины отказа</ButtonComponent
                        >
                      </div>
                    </div>
                  </div>
                  <div class="card-mpk__card-col2 documents-container">
                    <p class="title-column">Документы</p>
                    <div v-if="item.assignmentFiles && item.assignmentFiles.length" class="documents-column">
                      <div
                        v-for="assignmentFile in item.assignmentFiles"
                        :key="assignmentFile.fileId"
                        class="documents-files"
                      >
                        <p class="report-name">
                          <a href="javascript:" @click.prevent="downloadAssignmentFile(assignmentFile)">
                            <IconComponent name="doc-redesigned" class="tooltip-component__icon" />
                          </a>
                          {{ assignmentFile.fileText }}
                        </p>
                        <p v-if="assignmentFile.file.originalName" class="documents-text">
                          <a href="javascript:" @click.prevent="downloadAssignmentFile(assignmentFile)">
                            {{ assignmentFile.file.originalName }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Связанные мероприятия -->
                <div v-if="item.eventName" class="card-mpk__card-row report">
                  <div class="card-mpk__card-col1">
                    <p class="title-column">Связанное мероприятие/объект</p>
                    <p>{{ item.eventName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabItem>

        <!-- ТАБ: История изменений  -->
        <TabItem name="История изменений">
          <div class="history-card">
            <table class="history-table">
              <thead>
                <tr>
                  <th>Пользователь</th>
                  <th class="history-table__not_name">Дата и время</th>
                  <th class="history-table__not_name">Cтатус</th>
                </tr>
              </thead>
              <tbody v-if="statusHistoryData.items && statusHistoryData.items.length">
                <tr v-for="record in statusHistoryData.items" :key="record.id">
                  <td>
                    {{ record.employeeFullName }}
                    <span v-if="record.employeeEmail" class="history-table__email"> ({{ record.employeeEmail }}) </span>
                  </td>
                  <td class="history-table__not_name">
                    {{ $momentFormat(record.modifiedAt, 'DD.MM.YYYY') }}
                    <div>
                      {{ $momentFormat(record.modifiedAt, 'HH:mm:ss') }}
                    </div>
                  </td>

                  <td class="history-table__not_name">
                    <div class="d-flex history-table__status">
                      {{ record.newStatusName }}
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="history-table__empty">Нет данных</td>
                </tr>
              </tbody>
            </table>
            <PaginationRedesigned
              v-if="statusHistoryData.pagesTotal > 1"
              :currentPage="statusHistoryData.pageNumber"
              :pageCount="statusHistoryData.pagesTotal"
              :isShowMoreVisible="
                statusHistoryData.firstItemNumber + statusHistoryData.itemCount < statusHistoryData.itemCount
              "
              @change="loadHistory($event)"
            />
          </div>
        </TabItem>
      </Tab>

      <div class="mt-3 d-flex card-mpk__footer-btns">
        <ButtonComponent mod="border" @click="close">Закрыть</ButtonComponent>
        <ButtonComponent
          v-if="
            isGeneralInfoTab &&
            item.canPostponeStatus &&
            !item.postponed &&
            (item.statusId === EAP_ASSIGMENT_STATUS_ID.new || item.statusId === EAP_ASSIGMENT_STATUS_ID.inProgress)
          "
          mod="border"
          @click="setPostponed"
          >Отменить</ButtonComponent
        >
        <ButtonComponent
          v-if="isGeneralInfoTab && item.canPostponeStatus && item.postponed"
          mod="border"
          @click="setPostponed"
          >Возобновить</ButtonComponent
        >
      </div>

      <!--  Модалки  -->
      <ModalComponent title="Отклонить" @close="dialogCancel = false" v-model="dialogCancel">
        <div class="form__body cancel">
          <div class="form__body-inputBlock required mb-16">
            <label class="form-label">Причина</label>
            <textarea placeholder="Напишите причину отклонения" v-model="reason"></textarea>
            <div class="invalid-msg" v-if="v$.reason.$error">Поле обязательно для заполнения</div>
          </div>
          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="cancelReportSend">Подтвердить</ButtonComponent>
            <ButtonComponent mod="border" @click="dialogCancel = false">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Внести отчет" @close="dialogMakeReport = false" v-model="dialogMakeReport">
        <div class="form__body cancel">
          <div class="form__body-inputBlock required mb-16">
            <label class="form-label">Отчет</label>
            <textarea placeholder="Вставьте или напишите здесь текст отчета" v-model="modal.report"></textarea>
            <div class="invalid-msg" v-if="v$.modal.report.$error">Поле обязательно для заполнения</div>
          </div>

          <div class="documents-section">
            <div v-for="(document, index) in modal.reportFiles" :key="index" class="document-row">
              <div class="document-fields form-grid form-grid--gutter-medium">
                <div class="form-grid__item form-grid__item--half max-width">
                  <Field label="Файл к отчету">
                    <FileUpload
                      :entity="document"
                      propName="file"
                      label="Выберите файл +"
                      width="100%"
                      :required="false"
                      @uploaded="onReportFileUploaded($event, index)"
                      @deleteFile="onReportFileDelete($event, index)"
                      deleteInnerFileOnButton
                    />
                  </Field>
                </div>
                <div class="form-grid__item form-grid__item--half max-width">
                  <Field label="Описание файла">
                    <ComponentInput
                      placeholder="Введите описание файла"
                      v-model="document.fileText"
                      type="input"
                      mod="rectangular"
                      :maxLength="100"
                    />
                  </Field>
                </div>
              </div>
            </div>
            <div class="form-grid__caption">
              Возможна загрузка до 10 файлов в форматах: .docx, .xlsx, .pptx, .pdf, .jpeg, .png - размером не более 20
              Мб
            </div>
            <div class="form-grid__item" v-if="modal.reportFiles.length < 10">
              <ButtonComponent mod="gradient-bg" @click.prevent="addReportDocument">+ Добавить файл</ButtonComponent>
            </div>
          </div>

          <div>
            <ButtonComponent class="mr-8 mb-6" mod="gradient-bg" @click="createReportSend">Сохранить</ButtonComponent>
            <ButtonComponent mod="border" @click="dialogMakeReport = false">Отмена</ButtonComponent>
          </div>
        </div>
      </ModalComponent>

      <ModalComponent title="Причины отказа" @close="dialogRefuse = false" v-model="dialogRefuse">
        <div class="form__body cancel">
          <div class="form__body-inputBlock mb-16">
            <template v-for="reason in refuseReasons" :key="reason.id">
              <p>
                {{ reason.createdBy.fullName }} ({{
                  $momentFormat(reason.created, Constants.DATE_FORMATS.DD_MMMM_YYYY)
                }})
              </p>
              <div>{{ reason.reason }}</div>
            </template>
          </div>
          <div>
            <ButtonComponent mod="border" @click="dialogRefuse = false">Закрыть</ButtonComponent>
          </div>
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required } from '@vuelidate/validators';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import Field from '@/common/components/Field.vue';
  import FileUpload from '@/common/components/FileUpload.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import PaginationRedesigned from '@/common/components/redesigned/PaginationRedesigned.vue';
  import Tab from '@/common/components/redesigned/Tabs/Tab.vue';
  import TabItem from '@/common/components/redesigned/Tabs/TabItem.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import { EAP_ASSIGMENT_STATUS_ID } from '@/modules/eap/utils/constants';

  import API from '../api/assignment';
  import { isDeadlineOverdue } from '../utils/deadline';

  export default {
    name: 'EapAssignmentCard',
    components: {
      Tab,
      TabItem,
      PaginationRedesigned,
      ButtonComponent,
      IconComponent,
      ModalComponent,
      FileUpload,
      ComponentInput,
      Field,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        Constants: Constants,

        selectedTabIndex: 0,
        item: {},
        statusHistoryData: {},
        modal: {
          report: '',
          reportFiles: [],
        },
        reason: '',
        refuseReasons: [],
        dialogMakeReport: false,
        dialogCancel: false,
        dialogRefuse: false,

        EAP_ASSIGMENT_STATUS_ID: EAP_ASSIGMENT_STATUS_ID,
      };
    },
    computed: {
      isOverdue() {
        return isDeadlineOverdue(this.item);
      },
      isGeneralInfoTab() {
        return this.selectedTabIndex === 0;
      },
    },
    async created() {
      const isAllowed = await this.checkPermissionAndRedirect(Constants.Permissions.EapAssignmentAccess);
      if (!isAllowed) return;

      this.loadCard();
    },
    methods: {
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;
          });
          this.loadHistory();
        } else {
          this.close();
        }
      },
      loadHistory(page = 1) {
        API.getStatusHistory(this.id, page).then((response) => {
          this.statusHistoryData = response.data ?? {};
        });
      },
      setPostponed() {
        API.setPostponed(this.item.id, !this.item.postponed)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      createReport() {
        this.modal = {
          report: this.item.report || '',
          reportFiles:
            this.item.reportFiles && this.item.reportFiles.length > 0
              ? this.item.reportFiles.map((fileItem) => ({
                  fileId: fileItem.fileId,
                  file: fileItem.file,
                  fileText: fileItem.fileText || '',
                }))
              : [{ file: null, fileText: '' }],
        };
        this.dialogMakeReport = true;
      },
      createReportSend() {
        this.v$.$touch();
        if (this.v$.modal.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        const itemToSave = {
          id: this.item.id,
          report: this.modal.report,
          reportFiles: this.modal.reportFiles
            .filter((doc) => doc.file && doc.file.id)
            .map((doc) => ({ fileId: doc.file.id, fileText: doc.fileText || '' })),
        };
        API.updateReport(itemToSave)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.dialogMakeReport = false;
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      cancelReport() {
        this.dialogCancel = true;
      },
      cancelReportSend() {
        this.v$.$touch();
        if (this.v$.reason.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        API.refuseReport({ assignmentId: this.item.id, reason: this.reason })
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.dialogCancel = false;
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      nextStep() {
        API.approveReport({ id: this.item.id })
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      updateStatus(statusId) {
        API.updateStatus(this.item.id, statusId)
          .then(() => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            this.loadCard();
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      // Отменено - вычисляемые состояния, не отдельные ID в БД.
      getCardStatusDotClass(assignment) {
        if (assignment.postponed && assignment.statusId !== EAP_ASSIGMENT_STATUS_ID.completed) return 'dot--postponed';
        return this.getHistoryStatusClass(assignment.statusId);
      },
      getHistoryStatusClass(statusId) {
        const map = {
          [EAP_ASSIGMENT_STATUS_ID.new]: 'dot--new',
          [EAP_ASSIGMENT_STATUS_ID.inProgress]: 'dot--in-progress',
          [EAP_ASSIGMENT_STATUS_ID.underReview]: 'dot--under-review',
          [EAP_ASSIGMENT_STATUS_ID.completed]: 'dot--completed',
          [EAP_ASSIGMENT_STATUS_ID.inApproval]: 'dot--in-approval',
        };
        return map[statusId] ?? '';
      },
      close() {
        this.$router.push({ name: 'EapAssignments' });
      },
      showRefuseReason() {
        this.dialogRefuse = true;
        this.refuseReasons = this.item.refuses;
      },
      addReportDocument() {
        if (this.modal.reportFiles.length < 10) {
          this.modal.reportFiles.push({ file: null, fileText: '' });
        }
      },
      onReportFileUploaded(event, index) {
        this.modal.reportFiles[index].file = event.data;
      },
      onReportFileDelete(event, index) {
        if (this.modal.reportFiles[index].file) {
          this.modal.reportFiles[index].file = null;
          this.modal.reportFiles[index].fileText = '';
        } else if (this.modal.reportFiles.length > 1) {
          this.modal.reportFiles.splice(index, 1);
        } else {
          this.modal.reportFiles[0] = { file: null, fileText: '' };
        }
      },
      downloadReportFile(reportFile) {
        const url = Utils.getFileUrl(reportFile.file.id);
        Utils.downloadFile(url, reportFile.file.originalName, {}, true);
      },
      downloadAssignmentFile(assignmentFile) {
        const url = Utils.getFileUrl(assignmentFile.file.id);
        Utils.downloadFile(url, assignmentFile.file.originalName, {}, true);
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        modal: { report: { required } },
        reason: { required },
      };
    },
  };
</script>

<style lang="scss" scoped>
  .required .form-label:after {
    content: '*';
    color: red;
    margin-left: 2px;
  }
  :deep(.label-input) {
    padding: 10px 16px 5px 16px;
  }
  :deep(.invalid-msg) {
    margin-top: 0;
  }

  .card-mpk::v-deep {
    .tabs-redesign__list {
      width: min-content !important;
    }
  }

  .card-mpk {
    &__title {
      margin-bottom: 24px;
    }
    &__body {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: flex-start;
    }
    &__card {
      padding: 30px;
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 17px rgba(55, 55, 55, 0.08);
      border-radius: 5px;

      &-row {
        display: flex;
        width: 100%;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 1px solid #d7d7d7;

        p {
          font-weight: 300;
          font-size: 14px;
          line-height: 150%;
          color: #343c44;
          margin-bottom: 0px;

          &.title-column {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            color: #343c44;
            margin-bottom: 10px;
          }
        }
      }

      &-col {
        &1 {
          padding-right: 16px;
          flex: 1;
        }
        &2 {
          flex: 1;
        }
      }
    }

    &__footer-btns {
      gap: 8px;
      flex-wrap: wrap;
    }
  }

  .history-card {
    margin-top: 0;
    border-radius: 0 0 5px 5px;
    padding: 0;
  }

  .history-table {
    width: 100%;
    border-collapse: collapse;

    thead tr {
      border-bottom: 2px solid $green;
    }

    th {
      padding: 16px 20px;
      font: $fira-14-M;
      color: $dark-grey-1;
      text-align: left;
      font-weight: 500;
    }

    tbody tr {
      border-bottom: 1px solid $light-grey-5;
    }

    td {
      padding: 16px 20px;
      font-size: 14px;
      color: #343c44;
      vertical-align: middle;
    }

    &__email {
      color: $dark-grey-1;
    }

    &__not_name {
      width: 25%;
    }

    &__status {
      align-items: center;
      gap: 8px;
    }

    &__dot {
      @extend .status-dot;
    }

    &__empty {
      padding: 32px 20px;
      color: $dark-grey-1;
      text-align: center;
    }
  }

  .report {
    &-name {
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      margin-left: 6px;
      color: #787f8f;
    }
    &-text {
      margin-bottom: 8px;
    }
    &-files {
      margin-bottom: 16px;
    }
    &-column {
      .btn-container button {
        margin-right: 8px;
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  .documents {
    &-text {
      margin-bottom: 8px;
      margin-left: 6px;
    }
    &-files {
      margin-bottom: 16px;
    }
  }

  .status-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    margin-right: 8px;

    &.dot--new {
      background-color: $blue;
    }
    &.dot--in-progress {
      background-color: $yellow;
    }
    &.dot--under-review {
      background-color: $purple;
    }
    &.dot--completed {
      background-color: $approval-text;
    }
    &.dot--in-approval {
      background-color: $purple;
    }
    &.dot--overdue {
      background-color: $red-2;
    }
    &.dot--postponed {
      background-color: $red;
    }
  }

  .status {
    &-container {
      gap: 8px;
    }
    &-container span {
      font-size: 14px;
    }
    &-done {
      color: $approval-text;
    }
    &-close {
      color: $red;
    }
    &-late {
      color: $red;
    }
    &-inWork {
      color: $yellow;
    }
  }

  .card-mpk__card-col2 p.deadline--overdue {
    color: $red;
  }

  .tooltip-component__icon {
    display: inline-block;
  }

  .document-row {
    margin-bottom: 5px;
    padding-bottom: 24px;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
    }
  }
  .documents-section {
    margin-bottom: 24px;
  }
  .form-grid {
    display: grid;
    grid-row-gap: var(--form-grid-gutter, 40px);
    grid-column-gap: 24px;
    grid-template-columns: 1fr 1fr;
    &--gutter-medium {
      --form-grid-gutter: 24px;
    }
    &__item {
      grid-column: span 2;
      &--half {
        grid-column: span 1;
        @media (max-width: $mobile) {
          grid-column: span 2;
        }
      }
    }
    &__caption {
      color: $gray-silver-dark;
      font-size: 0.95rem;
      margin-bottom: 24px;
    }
  }
  .max-width {
    max-width: 250px;
  }

  @media (max-width: $laptop) {
    .card-mpk__card-row {
      display: block;
      border-bottom: 0px;
      margin-bottom: 0px;
      padding-bottom: 0px;

      .card-mpk__card-col1 {
        margin-bottom: 16px;
        width: 100%;
        border-bottom: 1px solid #d7d7d7;
        padding-bottom: 16px;
      }
      .card-mpk__card-col2 {
        width: 100%;
        padding-right: 0;
        border-bottom: 1px solid #d7d7d7;
        margin-bottom: 16px;
        padding-bottom: 16px;
      }
      &.report {
        .card-mpk__card-col2 {
          order: 0;
          margin-bottom: 8px;
        }
        .card-mpk__card-col1 {
          order: 1;
        }
        .btn-container {
          flex-wrap: wrap;
        }
      }
    }
  }
</style>
